import { render, staticRenderFns } from "./ClothingDetection.vue?vue&type=template&id=ace807a6&scoped=true&"
import script from "./ClothingDetection.vue?vue&type=script&lang=js&"
export * from "./ClothingDetection.vue?vue&type=script&lang=js&"
import style0 from "./ClothingDetection.vue?vue&type=style&index=0&id=ace807a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace807a6",
  null
  
)

export default component.exports